import React from 'react';
import CheckboxInput from '../../../../muiComponents/CheckboxInput';
import { useServerNotifications } from '../../../../contexts/ServerNotificationsContext';
import { ServerNotification } from '../../../../types/serverNotifications/serverNotificationTypes';
import useTranslate from '../../../../customHooks/useTranslate';

/**
 * Resolves an alert only after the backend confirms the operation.
 * @param props The notification to resolve.
 * @returns A controlled resolution checkbox.
 */
const ResolveNotificationCheckbox = ({
    notification,
}: {
    notification: ServerNotification;
}) => {
    const translate = useTranslate();
    const { markAsResolved, isResolving } = useServerNotifications();

    const handleResolve = async () => {
        await markAsResolved(notification.id);
    };

    return (
        <CheckboxInput
            checked={notification.resolved}
            disabled={notification.resolved || isResolving}
            onChange={() => void handleResolve()}
            inputProps={{
                'aria-label': `${translate('resolve_notification')}: ${
                    notification.description
                }`,
            }}
        />
    );
};

export default ResolveNotificationCheckbox;
